import "core-js/modules/es6.number.constructor";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  name: "taskCard",
  props: {
    cardData: Object,
    activeReport: Object
  },
  data: function data() {
    return {};
  },
  created: function created() {},
  computed: {
    handleTagStyle: function handleTagStyle() {
      switch (this.cardData.status) {
        case "0":
          return "red";

        case "1":
          return "";

        case "2":
          return "gray";

        case "3":
          return "orange";

        case "4":
          return "purple";

        default:
          return "";
      }
    },
    handleReportStatus: function handleReportStatus() {
      switch (this.cardData.status) {
        case "0":
          return "完结";

        case "1":
          return "办理中";

        case "2":
          return "暂停";

        case "3":
          return "中止";

        case "4":
          return "系统中止";

        default:
          return "";
      }
    },
    handleReportRate: function handleReportRate() {
      var val = this.cardData.reportRate;

      if (!val) {
        return 0;
      }

      return Number(val.substring(0, val.length - 1));
    }
  },
  methods: {},
  watch: {},
  filters: {}
};